import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.states';
import { UsersSelectors } from 'src/app/features/users/state/users.selector-types';

@Component({
  selector: 'app-banner-laft',
  templateUrl: './banner-laft-profile.component.html',
  styleUrls: ['./banner-laft-profile.component.scss'],
})
export class BannerLaftProfileComponent implements OnInit {
  @Input() title;
  @Input() description;
  @Input() iconPath;
  @Input() actionButton = false;
  @Input() buttonText;
  @Input() buttonVariant;
  @Input() status: 'pending' | 'incomplete' | 'error' | 'inReview' | 'unsigned' | 'validating' | 'pendingPep' | 'postPepSubmitWaiting' = 'incomplete';
  @Output() clickEvent = new EventEmitter();
  profile;

  ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit(): void {
    this.store
      .select(UsersSelectors.profile())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(profile => {
        if (profile) {
          this.profile = profile;
        }
      });
  }

  getDefaultIconPath(): string {
    const icons = {
      pending: '../../../../../assets/icons/security-user.svg',
      incomplete: '../../../../../assets/icons/security-user.svg',
      error: '../../../../../assets/icons/warning-2.svg',
      inReview: '../../../../../assets/icons/security-user.svg',
      unsigned: '../../../../../assets/icons/security-user.svg',
      validating: '../../../../../assets/icons/security-user.svg',
      pendingPep: '../../../../../assets/icons/security-user.svg',
      postPepSubmitWaiting: '../../../../../assets/icons/security-user.svg',
    };
    return icons[this.status];
  }

  getDefaultButtonVariant(): 'filled' | 'outlined' {
    const variants = {
      pending: 'filled' as const,
      incomplete: 'filled' as const,
      error: 'outlined' as const,
      inReview: 'filled' as const,
      unsigned: 'filled' as const,
      validating: 'filled' as const,
      pendingPep: 'filled' as const,
      postPepSubmitWaiting: 'filled' as const,
    };
    return variants[this.status];
  }
}
